// Login page
import React, { useState } from 'react';
import GoogleLogin from 'react-google-login';
import { useNavigate } from 'react-router-dom';
import shareVideo from '../assets/share.mp4';
import logo from '../assets/logowhite.png';
import { client } from '../client';

// Google API token
const clientId = process.env.REACT_APP_GOOGLE_API_TOKEN;

const Login = () => {
  // Navigate to a new route
  const navigate = useNavigate();

  // States
  const [isVisible, setIsVisible] = useState(true);

  // Handle hide
  const handleHide = () => {
    // Hide the message
    setIsVisible(false);
  };

  // Handle show
  return (
    <div className='flex justify-start items-center flex-col h-screen'>
      <div className='relative w-full h-full'>
        {/* Background video  */}
        <video
          src={shareVideo}
          type='video/mp4'
          loop
          controls={false}
          muted
          autoPlay
          className='w-full h-full object-cover'
        />
        <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay">
          <div className='p-5'>
            <img src={logo} width="300px" alt="logo" />
          </div>
          <div className='shadow-2xl'>
            <div id="signInButton">

              {/* Google login button */}
              <GoogleLogin
                clientId={clientId}
                buttonText='Log in with Google'
                onSuccess={credentialResponse => {
                  // Store the user in local storage
                  localStorage.setItem('user', JSON.stringify(credentialResponse.profileObj));

                  // Get the user's name, googleId and image
                  const { name, googleId, imageUrl } = credentialResponse.profileObj;

                  // Create a new user
                  const doc = {
                    _id: googleId,
                    _type: 'user',
                    userName: name,
                    image: imageUrl,
                  }
                  // Create a new user if it doesn't exist
                  client.createIfNotExists(doc).then(() => {
                    navigate('/', { replace: true })
                  })
                }}
                cookiePolicy={'single_host_origin'}
                isSignedIn={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
